'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import H3 from 'UIComponents/elements/headings/H4';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIButton from 'UIComponents/button/UIButton';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIPopoverBody from 'UIComponents/tooltip/UIPopoverBody';
import UIPopoverCloseButton from 'UIComponents/tooltip/UIPopoverCloseButton';
import UIPopoverHeader from 'UIComponents/tooltip/UIPopoverHeader';
import EmailV3RenderingLimitations from 'DesignEditorsUI/components/shared/controls/EmailV3RenderingLimitations';

function EmailV3RenderingPopover() {
  const [open, setOpen] = useState(false);
  return /*#__PURE__*/_jsx(UIPopover, {
    content: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(UIPopoverHeader, {
        children: [/*#__PURE__*/_jsx(H3, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "DesignEditorsUI.shared.programmableEmail.crmTokensHeading"
          })
        }), /*#__PURE__*/_jsx(UIBadge, {
          className: "m-x-3",
          use: "beta",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "DesignEditorsUI.shared.programmableEmail.beta"
          })
        }), /*#__PURE__*/_jsx(UIPopoverCloseButton, {
          popoverUse: "longform",
          onClick: () => setOpen(false)
        })]
      }), /*#__PURE__*/_jsx(UIPopoverBody, {
        children: /*#__PURE__*/_jsx(EmailV3RenderingLimitations, {})
      })]
    }),
    open: open,
    placement: "bottom",
    use: "longform",
    width: 420,
    children: /*#__PURE__*/_jsx(UIButton, {
      className: "p-left-0",
      onClick: () => setOpen(value => !value),
      size: "small",
      use: "transparent",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "DesignEditorsUI.customWidgetEditor.toolbar.isEnabledForEmailV3Rendering.helpLink"
      })
    })
  });
}

export default EmailV3RenderingPopover;